class ShiftService {
  // Constants for localStorage keys
  static SHIFT_STORAGE_KEY = 'current_shift';
  static SHIFT_STATE_KEY = 'shift_state';
  
  // Initialize shift in localStorage
  static initializeShift = () => {
    if (!localStorage.getItem(this.SHIFT_STORAGE_KEY)) {
      const initialShift = {
        routeId: null,
        inventoryId: null,
        startTime: null,
        endTime: null,
        isActive: false,
        createdAt: new Date().toISOString()
      };
      localStorage.setItem(this.SHIFT_STORAGE_KEY, JSON.stringify(initialShift));
    }
  };
  
  // Start a new shift
  static startShift = (routeId, inventoryId) => {
    const shift = {
      routeId,
      inventoryId,
      startTime: new Date().toISOString(),
      endTime: null,
      isActive: true,
      lastUpdated: new Date().toISOString()
    };
    
    localStorage.setItem(this.SHIFT_STORAGE_KEY, JSON.stringify(shift));
    localStorage.setItem(this.SHIFT_STATE_KEY, 'active');
    
    return shift;
  };
  
  // End current shift
  static endShift = () => {
    const shift = this.getCurrentShift();
    
    if (shift.isActive) {
      shift.endTime = new Date().toISOString();
      shift.isActive = false;
      shift.lastUpdated = new Date().toISOString();
      
      localStorage.setItem(this.SHIFT_STORAGE_KEY, JSON.stringify(shift));
      localStorage.removeItem(this.SHIFT_STATE_KEY);
    }
    
    return shift;
  };
  
  // Get current shift
  static getCurrentShift = () => {
    const shiftStr = localStorage.getItem(this.SHIFT_STORAGE_KEY);
    return shiftStr ? JSON.parse(shiftStr) : null;
  };
  
  // Check if shift is active
  static isShiftActive = () => {
    const shift = this.getCurrentShift();
    return shift && shift.isActive === true;
  };
  
  // Get active route ID
  static getActiveRouteId = () => {
    const shift = this.getCurrentShift();
    return shift && shift.isActive ? shift.routeId : null;
  };
  
  // Get active inventory ID
  static getActiveInventoryId = () => {
    const shift = this.getCurrentShift();
    return shift && shift.isActive ? shift.inventoryId : null;
  };
  
  // Update shift data
  static updateShift = (updates) => {
    const shift = this.getCurrentShift();
    
    if (shift) {
      const updatedShift = {
        ...shift,
        ...updates,
        lastUpdated: new Date().toISOString()
      };
      
      localStorage.setItem(this.SHIFT_STORAGE_KEY, JSON.stringify(updatedShift));
      return updatedShift;
    }
    
    return null;
  };
  
  // Clear shift data
  static clearShift = () => {
    localStorage.removeItem(this.SHIFT_STORAGE_KEY);
    localStorage.removeItem(this.SHIFT_STATE_KEY);
  };
  
  // Get shift duration
  static getShiftDuration = () => {
    const shift = this.getCurrentShift();
    
    if (shift && shift.startTime) {
      const startTime = new Date(shift.startTime);
      const endTime = shift.endTime ? new Date(shift.endTime) : new Date();
      const durationMs = endTime - startTime;
      
      // Convert to hours and minutes
      const hours = Math.floor(durationMs / (1000 * 60 * 60));
      const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));
      
      return { hours, minutes };
    }
    
    return { hours: 0, minutes: 0 };
  };
  
  // Format shift duration for display
  static formatShiftDuration = () => {
    const { hours, minutes } = this.getShiftDuration();
    
    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }
    
    return `${minutes}m`;
  };
}

export default ShiftService;